module.exports = __webpack_public_path__ + "static/token-3e1c6b80487170b457d4b83b67e3e11e.svg";